import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CollapsibleContext } from './CollapsibleAdvanced';
function CollapsibleVisible(_ref) {
  let {
    children,
    whenOpen: visibleWhenOpen,
    whenClosed: visibleWhenClosed
  } = _ref;
  const {
    isOpen
  } = useContext(CollapsibleContext);
  const isVisible = isOpen && visibleWhenOpen || !isOpen && visibleWhenClosed;
  if (isVisible) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return null;
}
CollapsibleVisible.propTypes = {
  /** Specifies contents of the component. */
  children: PropTypes.node,
  /** Specifies whether the content should be visible when `Collapsible` is open. */
  whenOpen: PropTypes.bool,
  /** Specifies whether the content should be visible when `Collapsible` is closed. */
  whenClosed: PropTypes.bool
};
CollapsibleVisible.defaultProps = {
  children: undefined,
  whenOpen: false,
  whenClosed: false
};
export default CollapsibleVisible;
//# sourceMappingURL=CollapsibleVisible.js.map